import { Component, OnInit, OnDestroy } from '@angular/core';
import { CurrentUserService } from 'src/app/core/services/current-user.service';
import { Location } from '@angular/common';
import { RedirctUrlService } from 'src/app/shared/services/redirct-url.service';
import { AppNotificationService } from 'src/app/shared/services/app-notification.service'
import { HeaderService } from 'src/app/shared/services/header/header.service';

@Component({
  selector: 'app-update-supplier-user',
  templateUrl: './update-supplier-user.component.html',
  styleUrls: ['./update-supplier-user.component.scss']
})
export class UpdateSupplierUserComponent implements OnInit {
  public notifications: any[] = [];
  constructor(
    public currentUserService:CurrentUserService,
    private _redirectUrl: RedirctUrlService,
    private location: Location,
    public _header: HeaderService,
    public appNotificationsService: AppNotificationService) { }

  currentUser: string;
  async ngOnInit() {
    this.currentUserService.getUser().then(user => {
      this.currentUser = this.currentUserService.user.firstname;
    });

    if (await this.appNotificationsService.getNotificationEnabledStatus()) this.appNotificationsService.loadNotifications('general', 0);
  }

  ngOnDestroy() {
    
  }

  onDeactivate() {
    document.body.scrollTop = 0;
  }

  public onRedirectHandler($event) {
    this._redirectUrl.onLogoutHandler($event);
  }

  public onBackEventHandler() {
    this.location.back();
  }

}
